import { state } from "./state.js";

// Central lookup for display toggles (showTotalTime, showRankingAll, showSectors, ...).
// Server-pushed values (state.serverSettings, filled from session telegrams) win over the
// static config.json so a flag can move from client config to server control without
// touching call sites.
export function getSetting(key) {
  const serverValue = state.serverSettings[key];
  if (serverValue !== undefined) return serverValue;
  return state.configJSON ? state.configJSON[key] : undefined;
}
